import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"

import { ProcurementType } from "~/api/types/ProcurementList"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"
import { formatDateNew } from "~/helpers/formatDate"

import styles from "./index.module.css"

export const TopCell: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.Top}>
      <div className={styles.Date}>
        <Raw html={t("procurements.Table.Title.01")} />
      </div>
      {/*<div className={styles.Categories}>*/}
      {/*  <Raw html={t("procurements.Table.Title.02")} />*/}
      {/*</div>*/}
      {/*<div className={styles.NameWrapper}>*/}
      {/*  <Raw html={t("procurements.Table.Title.03")} />*/}
      {/*</div>*/}
    </div>
  )
}

export const Cell: React.FC<ProcurementType> = ({
  dateFrom,
  dateTo,
  categories,
  name,
  code,
  link,
}) => {
  const { t } = useTranslation()

  return (
    <div className={styles.Item}>
      <div className={styles.Date}>
        <div className={styles.Title}>
          <Raw html={t("procurements.Table.Title.01")} />
        </div>
        {formatDateNew(dateFrom, "d MMMM yyyy")}&nbsp; &mdash;
        <br className="d-none d-sm-block d-lg-none" /> {formatDateNew(dateTo, "d MMMM yyyy")}
      </div>

      <div className={cn(styles.Categories, { "d-none d-sm-block": !!categories })}>
        {categories && (
          <>
            <div className={styles.Title}>
              <Raw html={t("procurements.Table.Title.02")} />
            </div>

            {categories.map(({ id, name }) => (
              <div key={id} className={styles.Category}>
                {name}
              </div>
            ))}
          </>
        )}
      </div>

      <div className={styles.NameWrapper}>
        <div className={styles.Title}>
          <Raw html={t("procurements.Table.Title.03")} />
        </div>
        <div>{name}</div>
        <div className={styles.Links}>
          <Link className={styles.Link} href={`/procurements/${code}`} view="arrow">
            <Raw html={t("procurements.Table.Link.01")} />
          </Link>

          {link && (
            <Link
              className={styles.Link}
              href={link}
              rel="noopener noreferrer"
              target="_blank"
              view="arrow"
            >
              <Raw html={t("procurements.Table.Link.02")} />
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
